import TrainsCarouselBaseController from '../../trains-base/controllers/trains-carousel-base-controller';

export default function TrainsCarouselController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(TrainsCarouselBaseController, {
        $scope,
        trainsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-carousel-controller.js